import React from "react";
import "./LoadingModal.css";
import { Box } from "@mui/material";

export const LoadingModal = ({ message }: { message: string }) => {
  return (
    <div className="loading-modal-overlay">
      <div className="loading-modal-content borderAnimation">
        <div className="loader-container">
            <p className="loading-message">{message}</p>
             <Box >
              <img
                src="/Comp_1.gif"
                alt="Background Animation"
              />
            </Box>
        </div>
      </div>
    </div>
  );
};
